import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronLeftSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"chevron-left-small"} maskId="square-filled-radius-0-stroke-1-IconChevronLeftSmall"><path fillRule="evenodd" clipRule="evenodd" d="M13.9999 7.29297L9.29282 12.0001L13.9999 16.7072L14.707 16.0001L10.707 12.0001L14.707 8.00008L13.9999 7.29297Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconChevronLeftSmall;
